module.exports = __webpack_public_path__ + "fonts/c217a61a37cdac09ff5ca9cce8780abd.svg";